export default __webpack_public_path__ + "static/media/AM.b6acf679.ico";